module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"archived":"Archived","price":"Price","removeAlternative":"Remove","score":"Score","scrollTo":"Scroll to laptop"}}')
  delete Component.options._Ctor
}
